<template>
    <div>
        <div v-show="!saveOrUpdateDialog.visible && !sysStudentTicketDialog.visible">
            <el-alert title="导出考场布置信息，填入考场号，教室号，座位号在上传" type="info" :closable="false" show-icon></el-alert>
            <!--搜索表单-->
            <div class="search-box selectType">
                <el-form ref="searchForm"  :inline="true" :rules="searchRules" :model="searchForm" >
                    <el-form-item label="年份:" prop="year">
                        <el-date-picker
                                size="mini"
                                v-model="searchForm.year"
                                type="year"
                                placeholder="选择年份"
                                format="yyyy"
                                value-format="yyyy">
                        </el-date-picker>
                    </el-form-item>
                     <el-form-item label="考生姓名:" prop="studentName">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.studentName" placeholder="请输入考生姓名"></el-input>
                    </el-form-item>
                     <el-form-item label="身份证号:" prop="idCard">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.idCard" placeholder="请输入身份证号"></el-input>
                    </el-form-item>
                     <el-form-item label="报考专业:" prop="examMajor">
                         <el-select v-model="searchForm.examMajor" size="mini" filterable placeholder="请选择专业">
                             <el-option v-for="item in majorList" :key="item.name" :label="item.name" :value="item.name">
                             </el-option>
                         </el-select>
                    </el-form-item>
                    <el-form-item label="考场号:" prop="examRoomNum">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.examRoomNum" placeholder="请输入考场号" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="教室号:" prop="classroomNum">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.classroomNum" placeholder="请输入教室号" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="准考证号:" prop="ticketNumber">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.ticketNumber" placeholder="请输入准考证号"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button plain size="mini" type="primary" icon="el-icon-search" id="findBtn" v-display:sysExamRoom-find @click="()=>{this.searchForm.pager.page=1;this.submit();}">查询</el-button>
                        <el-button plain size="mini" type="warning" icon="el-icon-refresh" @click="clear">清空</el-button>
                        <el-button plain size="mini" type="success" icon="el-icon-refresh-left" @click="()=>{this.searchForm.pager.page=1;this.submit();}">刷新</el-button>
                        <el-button plain size="mini" type="primary" v-display:sysExamRoom-saveTicketNum icon="el-icon-tickets" @click="saveTicketNum" >生成准考证</el-button>
                        <el-button plain size="mini" type="primary" v-display:sysExamRoom-save icon="el-icon-plus" @click="showAddDialog" >新增</el-button>
                        <el-button plain size="mini" type="primary" v-display:sysExamRoom-printTicketNum icon="el-icon-printer" @click="toSaveOrUpdate" >打印座位贴</el-button>
                        <el-dropdown>
                            <el-button type="primary" size="mini" plain style="margin: 0px 10px 0px 10px">
                                批量操作<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item><el-button size="mini" type="text" v-display:sysExamRoom-batchDelete icon="el-icon-delete" @click="batchDelete" >批量删除</el-button></el-dropdown-item>
                                <el-dropdown-item><el-button size="mini" type="text" v-display:sysExamRoom-leadingIn icon="el-icon-upload" @click="leadingInsysExamRoom">导入</el-button></el-dropdown-item>
                                <el-dropdown-item><el-button size="mini" type="text" v-display:sysExamRoom-export icon="el-icon-download" @click="exportsysExamRoom">导出</el-button></el-dropdown-item>
                                <el-dropdown-item><el-button size="mini" type="text" v-display:sysExamRoom-exportModule icon="el-icon-download" @click="exportsysExamRoomModule('upsertForm')">下载模板</el-button></el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </el-form-item>
                </el-form>
             </div>
            <!--表格-->
            <el-table border size="mini" class="table-ui" :stripe="true" height="70vh" :data="tableData" @selection-change="changeFun"  @sort-change="sortChange" >
                <el-table-column type="selection" width="40px" style="text-align: center;margin: auto"></el-table-column>
                <el-table-column type="index" width="50" label="序号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="studentName" label="考生姓名" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="sex" label="性别" width="60"></el-table-column>
                <el-table-column show-overflow-tooltip prop="idCard" label="身份证号" width="160"></el-table-column>
                <el-table-column show-overflow-tooltip prop="ticketNumber" label="准考证号" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="code" label="报名号" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="examMajor" label="报考专业" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="examRoomNum" label="考场号" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="classroomNum" label="教室号" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="seatNumber" label="座位号" sortable></el-table-column>
                <el-table-column label="操作" width="80"  >
                    <template slot-scope="scope">
                        <el-dropdown>
                            <span class="el-dropdown-link" style="color: #409EFF">
                            操作<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item><el-button type="text" v-display:sysExamRoom-update @click="showUpdateDialog(scope.row.id)">修改</el-button></el-dropdown-item>
                                <el-dropdown-item><el-button type="text" v-display:sysExamRoom-look @click="toLook($event,scope.row.id)">查看</el-button></el-dropdown-item>
                                <el-dropdown-item><el-button type="text" v-display:sysExamRoom-delete @click="deleteData(scope.row.id)">删除</el-button></el-dropdown-item>
                                <el-dropdown-item><el-button type="text" v-display:sysExamRoom-toSysStudentTicket @click="toSysStudentTicket($event,scope.row.studentId)">打印准考证</el-button></el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
                <div slot="empty"><no-data></no-data></div>
            </el-table>
            <el-pagination
                    style="margin-top: 10px;padding-bottom: 20px;"
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="searchForm.pager.totalCount"
                    :page-size="searchForm.pager.pageSize"
                    :current-page.sync="searchForm.pager.page"
                    :page-sizes="[10, 20, 30, 40, 50, 100]"
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    @prev-click="currentChange"
                    @next-click="currentChange"
            ></el-pagination>
            <!--添加或者修改表单-->
            <el-dialog :close-on-click-modal="false" :title="dialog.title"   width="1000px" :visible.sync="dialog.dialogFormVisible">
                <el-form class="upsertForm"  :model="upsertForm" :rules="rules" ref="upsertForm" label-width="100px" :inline="true">
                    <input type="hidden" :value="upsertForm.id">
                      <el-form-item label="学生序号" prop="sequence">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.sequence" placeholder="请输入学生序号" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="考生姓名" prop="studentName">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.studentName" placeholder="请输入考生姓名" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="性别" prop="sex">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.sex" placeholder="请输入性别" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="身份证号" prop="idCard">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.idCard" placeholder="请输入身份证号" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="报考专业" prop="examMajor">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.examMajor" placeholder="请输入报考专业" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="考场号" prop="examRoomNum">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.examRoomNum" placeholder="请输入考场号" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="教室号" prop="classroomNum">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.classroomNum" placeholder="请输入教室号" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="座位号" prop="seatNumber">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.seatNumber" placeholder="请输入座位号" auto-complete="off"></el-input>
                     </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button plain size="mini"  @click="dialog.dialogFormVisible = false">取 消</el-button>
                    <el-button plain size="mini"  type="primary" v-if="dialog.title=='增加'" v-display:sysExamRoom-save @click="saveOrUpdate('upsertForm')">确 定</el-button>
                    <el-button plain size="mini"  type="primary" v-else v-display:sysExamRoom-update @click="saveOrUpdate('upsertForm')">确 定</el-button>
                </div>
            </el-dialog>
            <!--查看详情-->
            <el-dialog :close-on-click-modal="false" title="查看"   width="1000px" :visible.sync="lookVisible">
                <div>
                <el-form class="upsertForm" :inline="true" label-width="100px">
                   <el-form-item label="学生序号" prop="sequence">
                    <el-input size="mini" v-model="upsertForm.sequence" readonly auto-complete="off"></el-input>
                    </el-form-item>
                   <el-form-item label="考生姓名" prop="studentName">
                    <el-input size="mini" v-model="upsertForm.studentName" readonly auto-complete="off"></el-input>
                    </el-form-item>
                   <el-form-item label="性别" prop="sex">
                    <el-input size="mini" v-model="upsertForm.sex" readonly auto-complete="off"></el-input>
                    </el-form-item>
                   <el-form-item label="身份证号" prop="idCard">
                    <el-input size="mini" v-model="upsertForm.idCard" readonly auto-complete="off"></el-input>
                    </el-form-item>
                   <el-form-item label="报考专业" prop="examMajor">
                    <el-input size="mini" v-model="upsertForm.examMajor" readonly auto-complete="off"></el-input>
                    </el-form-item>
                   <el-form-item label="考场号" prop="examRoomNum">
                    <el-input size="mini" v-model="upsertForm.examRoomNum" readonly auto-complete="off"></el-input>
                    </el-form-item>
                   <el-form-item label="教室号" prop="classroomNum">
                    <el-input size="mini" v-model="upsertForm.classroomNum" readonly auto-complete="off"></el-input>
                    </el-form-item>
                   <el-form-item label="座位号" prop="seatNumber">
                    <el-input size="mini" v-model="upsertForm.seatNumber" readonly auto-complete="off"></el-input>
                    </el-form-item>
                </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button plain size="mini" class="large" @click="lookVisible = false">取 消</el-button>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" :title="dialogExcel.title"   width="650px" :visible.sync="dialogExcel.dialogFormVisible">
                <div v-if="dialogExcel.title=='导入结果'">
                <el-badge :value="cnt" class="item" style="margin: 10px 20px 10px 0px">
                    <el-button size="mini">导入总数</el-button>
                </el-badge>
                <el-badge :value="successCnt" class="item" type="primary" style="margin: 10px 20px 10px 10px">
                    <el-button size="mini">导入成功</el-button>
                </el-badge>
                <el-badge :value="errorNumber" class="item" type="warning" style="margin: 10px 20px 10px 10px">
                    <el-button size="mini">导入失败</el-button>
                </el-badge>
                <!--表格-->
                <el-table v-show="errorNumber>0" :stripe="true" :data="uploadData" style="margin-top: 10px">
                    <el-table-column show-overflow-tooltip prop="errorMsg" label="导入备注" width="200">
                        <template slot-scope="scope">
                            <span style="color: red">{{scope.row.errorMsg}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="studentName" label="考生姓名" ></el-table-column>
                    <el-table-column prop="sex" label="性别" ></el-table-column>
                    <el-table-column prop="idCard" label="身份证号" ></el-table-column>
                    <el-table-column prop="examMajor" label="报考专业" ></el-table-column>
                    <el-table-column prop="examRoomNum" label="考场号" ></el-table-column>
                    <el-table-column prop="classroomNum" label="教室号" ></el-table-column>
                    <el-table-column prop="seatNumber" label="座位号" ></el-table-column>
                </el-table>
            </div>
                <div v-if="dialogExcel.title=='导入'">
                    <el-upload class="lead-in-th"
                               style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #4dbd73 ;"
                               :action="uploadUrl"
                               :headers="headers"
                               multiple
                               :show-file-list="false"
                               :on-success="handlesysExamRoomSuccess"
                               :before-upload="beforesysExamRoomUpload">
                        <div class="" style="width: 440px;height: 50px;">导入</div>
                    </el-upload>
                    <div class="lead-in-th" @click="exportsysExamRoomModule('upsertForm')" style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #fff ;background-color: #51c993">下载模板</div>
                </div>
            </el-dialog>
        </div>
        <save-or-update-sys-exam-room v-if="saveOrUpdateDialog.visible" v-bind="saveOrUpdateDialog" @closeSaveOrUpdate="closeSaveOrUpdate"></save-or-update-sys-exam-room>
        <sys-student-ticket v-if="sysStudentTicketDialog.visible" v-bind="sysStudentTicketDialog" @closeSysStudentTicketDialog="closeSysStudentTicketDialog"></sys-student-ticket>
    </div>
</template>

<script>
    import axios from 'axios';
    import fileDownload from "js-file-download";
    import noData from '@/components/noData/noData';
    import saveOrUpdateSysExamRoom from './saveOrUpdateSysExamRoom';
    import sysStudentTicket from './sysStudentTicket';
    export default {
        name: "sysExamRoom",
        components: { noData,saveOrUpdateSysExamRoom,sysStudentTicket},
        data() {
            return {
                searchForm:{
                      adminId: '',
                      adminName: '',
                      sequence: '',
                      studentId: '',
                      studentName: '',
                      sex: '',
                      idCard: '',
                      examMajor: '',
                      examRoomNum: '',
                      classroomNum: '',
                      seatNumber: '',
                      ticketNumber:'',
                      updateTime: '',
                      createTime: '',
                    pager:{
                        sortField:'examRoomNum,seatNumber',
                        sortOrder:'asc,asc',
                        page:1,
                        pageSize:20,
                        totalCount:0,
                        like:'studentName,idCard,examMajor,examRoomNum,classroomNum,ticketNumber',
                        sortFieldNumber:'examRoomNum,seatNumber'
                    }
                },
                tableData: [],
                upsertForm:{
                        id:'',
                        adminId:'',
                        adminName:'',
                        sequence:'',
                        studentId:'',
                        studentName:'',
                        sex:'',
                        idCard:'',
                        examMajor:'',
                        examRoomNum:'',
                        classroomNum:'',
                        seatNumber:'',
                        ticketNumber:'',
                        updateTime:'',
                        createTime:''
                },
                searchRules: {
                          adminId: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          adminName: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          sequence: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          studentId: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          studentName: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          sex: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          idCard: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          examMajor: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          examRoomNum: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          classroomNum: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          seatNumber: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          updateTime: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          createTime: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                },
                rules: {
                          adminId: [
                                  { required: true, message: '请输入操作人编', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          adminName: [
                                  { required: true, message: '请输入操作人', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          sequence: [
                                  { required: true, message: '请输入学生序号', trigger: 'blur' },
                              ],
                          studentId: [
                                  { required: true, message: '请输入学生编号', trigger: 'blur' },
                              ],
                          studentName: [
                                  { required: true, message: '请输入考生姓名', trigger: 'blur' },
                              ],
                          sex: [
                                  { required: true, message: '请输入性别', trigger: 'blur' },
                              ],
                          idCard: [
                                  { required: true, message: '请输入身份证号', trigger: 'blur' },
                                  {  min: 18, max: 18, message: '长度必须18个字符', trigger: 'blur' }
                              ],
                          examMajor: [
                                  { required: true, message: '请输入报考专业', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          examRoomNum: [
                                  { required: true, message: '请输入考场号', trigger: 'blur' },
                              ],
                          classroomNum: [
                                  { required: true, message: '请输入教室号', trigger: 'blur' },
                              ],
                          seatNumber: [
                                  { required: true, message: '请输入座位号', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          updateTime: [
                                  { required: true, message: '请输入修改时间', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          createTime: [
                                  { required: true, message: '请输入创建时间', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                },
                dialog:{
                    dialogFormVisible:false,
                    title:'增加'
                },
                lookVisible:false,
                headers: {
                    token: this.$store.getters.getToken
                },
                rowData: [],
                cnt: '',
                successCnt: '',
                errorNumber: '',
                uploadData: [],
                uploadUrl: `${home}/sysExamRoom/importByExcel`,
                dialogExcel:{
                    dialogFormVisible:false,
                    title:'导入'
                },
                majorList:[],
                saveOrUpdateDialog:{
                    visible:false,
                    title:'增加',
                    id:''
                },
                sysStudentTicketDialog:{
                    visible:false,
                    title:'打印准考证',
                    id:''
                },
            }
        },
        created(){
            this.$set(this.searchForm,"year", new Date().getFullYear().toString())
            this.getMajorList();
        },
        mounted(){
            let findBtn=document.querySelector('#findBtn');
            findBtn&&this.submit();
        },
        methods: {
            changeFun(row) {
                this.rowData = [];
                for (var i = 0; i < row.length; i++) {
                    this.rowData.push(row[i].id);
                }
            },
            sortChange({ column, prop, order }){
                this.searchForm.pager.sortField=prop;
                this.searchForm.pager.sortOrder=order?order.replace(/ending$/,''):'';
                this.submit();
            },
            sizeChange(pageSize){
                this.searchForm.pager.pageSize=pageSize;
                this.submit();
            },
            currentChange(page){
                this.searchForm.pager.page=page;
                this.submit();
            },
            showAddDialog(){
                this.dialog.dialogFormVisible=true;
                this.dialog.title='增加';
                objUtil.setToDefault(this.upsertForm);
                this.$nextTick(()=>{
                    this.$refs.upsertForm.clearValidate();
                });
            },
            showUpdateDialog(id){
                axios({
                    url:`${home}/sysExamRoom/update/findSysExamRoomById/${id}`,
                    method:'GET'
                }).then(res=>{
                    Object.assign(this.upsertForm,res.data);
                    this.dialog.dialogFormVisible=true;
                    this.dialog.title = '修改';
                    this.$nextTick(()=>{
                        this.$refs.upsertForm.clearValidate();
                    });
                }).catch(error=>{

                })

            },
            saveOrUpdate(formName){
                this.$refs[formName].validate(valid=>{
                    if(valid){
                        axios({
                            url:`${home}/sysExamRoom/${this.dialog.title==='增加'?'saveSysExamRoom':'update/updateSysExamRoom'}`,
                            method:'POST',
                            data:this.upsertForm
                        }).then(res=>{
                            this.$message({
                                message: this.dialog.title+'成功',
                                type: 'success'
                            });
                            this.dialog.dialogFormVisible = false;
                            this.submit();
                        }).catch(error=>{
                            //do something
                        })
                    }
                })
            },
            deleteData(id){
                this.$confirm('删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios({
                        url: `${home}/sysExamRoom/deleteSysExamRoom/${id}`,
                        method: 'GET'
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.submit();
                    }).catch(error => {

                    })
                }).catch(() => {

                });

            },
            submit(){
                axios({
                    url:`${home}/sysExamRoom/findSysExamRoomsByCondition`,
                    method:'POST',
                    data:this.searchForm
                }).then(res=>{
                    if(res.data.length===0&&this.searchForm.pager.page>1&&res.totalCount>0){
                        this.searchForm.pager.page--;
                        this.submit();
                    }else{
                        this.tableData=res.data;
                        this.searchForm.pager.totalCount=res.totalCount;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            clear(){
                this.$refs['searchForm'].resetFields();
            },
            toLook($event,id){
                this.lookVisible=true;
                axios({
                    url:`${home}/sysExamRoom/look/lookSysExamRoomById/${id}`,
                    method:'GET'
                }).then(res=>{
                    Object.assign(this.upsertForm,res.data);
                }).catch(error=>{
                    console.log(error);
                })
            },
            leadingInsysExamRoom() {
                this.dialogExcel.dialogFormVisible = true;
                this.dialogExcel.title = '导入';
            },
            exportsysExamRoom() {
                axios({
                    url: `${home}/sysExamRoom/exportSysExamRoom`,
                    method: "POST",
                    data: this.searchForm,
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "考场布置.xls");
                });
            },
            exportsysExamRoomModule() {
                axios({
                    url: `${home}/sysExamRoom/exportSysExamRoomModule`,
                    method: "GET",
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "考场布置模板.xls");
                });

            },
            handlesysExamRoomSuccess(res, file) {
                this.loading.close();
                this.dialogExcel.dialogUploadVisible = false;
                if (res.result.success== true) {
                    if(res.data.successCnt>0){
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入成功",
                            type: "success"
                        });
                        this.submit();
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }else{
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入失败",
                            type: "warning"
                        });
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }
                } else{
                    this.$message({
                        message: "模板有误或数据为空",
                        type: "error"
                    });
                    this.dialogExcel.dialogUploadErrorVisible = true;
                }
            },
            beforesysExamRoomUpload(file) {
                this.loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                });
                const extension = file.name.split(".")[1] === "xls";
                const extension2 = file.name.split(".")[1] === "xlsx";
                if (!extension && !extension2) {
                    this.loading.close();
                    this.$message.error("上传模板只能是 xls、xlsx 格式!");
                }
                return extension || extension2;
            },
            batchDelete(){
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$confirm("确认批量删除吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    axios({
                        url: `${home}/sysExamRoom/batchDeleteSysExamRoom`,
                        method: "post",
                        data: {
                            rowData: this.rowData
                        }
                    }).then(res => {
                        this.$message({
                            type: "success",
                            message: "删除成功!"
                        });
                        this.submit();
                    }).catch(error => {});
                }).catch(() => {
                    this.$message({
                        type: "error",
                        message: "删除失败!"
                    });
                });
            },
            getMajorList(){
                axios({
                    url: `${home}/sysDdList/getMajorList`,
                    method: "GET",
                }).then(res => {
                    this.majorList = res.data;
                    this.yearList = res.data2;
                });
            },
            saveTicketNum(){
                axios({
                    url: `${home}/sysExamRoom/saveTicketNum`,
                    method: "GET",
                }).then(res => {
                    this.$message({
                        type: "success",
                        message: "准考证生成成功!"
                    });
                    this.submit();
                });
            },
            toSaveOrUpdate($event,id){
                this.saveOrUpdateDialog.title='座位帖';
                this.saveOrUpdateDialog.id=id;
                this.saveOrUpdateDialog.visible=true;
            },
            toSysStudentTicket($event,id){
                this.sysStudentTicketDialog.title='打印准考证';
                this.sysStudentTicketDialog.id=id;
                this.sysStudentTicketDialog.visible=true;
            },
            closeSaveOrUpdate(data){
                this.saveOrUpdateDialog.visible=false;
                this.submit();
            },
            closeSysStudentTicketDialog(data){
                this.sysStudentTicketDialog.visible=false;
                this.submit();
            },
        }
    }
</script>
<style lang="scss">
    .selectType{
        .el-input__inner{
            width: 150px;
        }
        .el-input .el-input--mini {
            width: 150px;
        }
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 150px;
        }
    }
</style>